import { Map, List, fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'

// constants
const JOB_TASKS_ADMIN = 'jobTasksAdmin'
export const FETCH_TASKS_TABLE_DATA = `${JOB_TASKS_ADMIN}/FETCH_TASKS_TABLE_DATA`
export const LOAD_TASK_TABLE_DATA = `${JOB_TASKS_ADMIN}/LOAD_TASK_TABLE_DATA`
export const FETCH_TASK_FORM_DATA = `${JOB_TASKS_ADMIN}/FETCH_TASK_FORM_DATA`
export const FETCH_TASK_POLICIES_LIST = `${JOB_TASKS_ADMIN}/FETCH_TASK_POLICIES_LIST`
export const CHANGE_TASK = `${JOB_TASKS_ADMIN}/CHANGE_TASK`
export const DELETE_TASK = `${JOB_TASKS_ADMIN}/DELETE_TASK`
export const CLEAR_TASKS_STATE = `${JOB_TASKS_ADMIN}/TASK_CLEAR_STATE`
export const CLEAR_TASKS_STATE_DATA = `${JOB_TASKS_ADMIN}/TASK_CLEAR_STATE_DATA`
export const CLEAR_TASK_FORM_DATA = `${JOB_TASKS_ADMIN}/TASK_CLEAR_FORM_DATA`
export const FETCH_WORKFLOW_LIST = `${JOB_TASKS_ADMIN}/FETCH_WORKFLOW_LIST`
export const TASKS_TABLE_POSITION_UPDATE_FETCH = `${JOB_TASKS_ADMIN}/TASKS_TABLE_POSITION_UPDATE_FETCH`
export const TASKS_TABLE_POSITION_UPDATE_SUCCESS = `${JOB_TASKS_ADMIN}/TASKS_TABLE_POSITION_UPDATE_SUCCESS`
export const CHANGE_TASK_ASSIGN = `${JOB_TASKS_ADMIN}/CHANGE_TASK_ASSIGN`
export const FETCH_TASK_ASSIGN_LIST = `${JOB_TASKS_ADMIN}/FETCH_TASK_ASSIGN_LIST`
export const DELETE_TASK_ASSIGN = `${JOB_TASKS_ADMIN}/DELETE_TASK_ASSIGN`
export const FETCH_TASK_INPUTS_TREE = `${JOB_TASKS_ADMIN}/FETCH_TASK_INPUTS_TREE`
export const SET_IS_INPUTS_TREE_FETCHING = `${JOB_TASKS_ADMIN}/SET_IS_INPUTS_TREE_FETCHING`

export const [
  FETCH_TASK_INPUTS_TREE_SUCCESS,
  FETCH_TASK_INPUTS_TREE_FAILURE,
] = [`${FETCH_TASK_INPUTS_TREE}_SUCCESS`, `${FETCH_TASK_INPUTS_TREE}_FAILURE`]
export const [FETCH_TASK_FORM_DATA_SUCCESS, FETCH_TASK_FORM_DATA_FAILURE] = [
  `${FETCH_TASK_FORM_DATA}_SUCCESS`,
  `${FETCH_TASK_FORM_DATA}_FAILURE`,
]

export const [FETCH_WORKFLOW_LIST_SUCCESS, FETCH_WORKFLOW_LIST_FAILURE] = [
  `${FETCH_WORKFLOW_LIST}_SUCCESS`,
  `${FETCH_WORKFLOW_LIST}_FAILURE`,
]

export const [
  FETCH_TASKS_TABLE_DATA_SUCCESS,
  FETCH_TASKS_TABLE_DATA_FAILURE,
] = [`${FETCH_TASKS_TABLE_DATA}_SUCCESS`, `${FETCH_TASKS_TABLE_DATA}_FAILURE`]

export const [
  FETCH_TASK_POLICIES_LIST_SUCCESS,
  FETCH_TASK_POLICIES_LIST_FAILURE,
] = [
  `${FETCH_TASK_POLICIES_LIST}_SUCCESS`,
  `${FETCH_TASK_POLICIES_LIST}_FAILURE`,
]

export const [
  FETCH_TASK_ASSIGN_LIST_SUCCESS,
  FETCH_TASK_ASSIGN_LIST_FAILURE,
] = [`${FETCH_TASK_ASSIGN_LIST}_SUCCESS`, `${FETCH_TASK_ASSIGN_LIST}_FAILURE`]

// actions
export const fetchWorkflowList = ActionHelper.createActionObj(
  FETCH_WORKFLOW_LIST,
)
export const tasksFetchTableData = ActionHelper.createActionObj(
  FETCH_TASKS_TABLE_DATA,
)
export const fetchTaskFormData = ActionHelper.createActionObj(
  FETCH_TASK_FORM_DATA,
)
export const fetchTaskPolicies = ActionHelper.createActionObj(
  FETCH_TASK_POLICIES_LIST,
)
export const tasksClearState = ActionHelper.createActionObj(CLEAR_TASKS_STATE)
export const fetchJobTaskPositionUpdate = ActionHelper.createActionObj(
  TASKS_TABLE_POSITION_UPDATE_FETCH,
)
export const taskClearStateList = ActionHelper.createActionObj(
  CLEAR_TASKS_STATE_DATA,
)
export const taskClearFormData = ActionHelper.createActionObj(
  CLEAR_TASK_FORM_DATA,
)
export const changeTask = ActionHelper.createActionObj(CHANGE_TASK)
export const deleteTask = ActionHelper.createActionObj(DELETE_TASK)
export const changeTaskAssign = ActionHelper.createActionObj(CHANGE_TASK_ASSIGN)
export const fetchTaskAssignList = ActionHelper.createActionObj(
  FETCH_TASK_ASSIGN_LIST,
)
export const deleteTaskAssign = ActionHelper.createActionObj(DELETE_TASK_ASSIGN)
export const fetchTaskInputsTree = ActionHelper.createActionObj(
  FETCH_TASK_INPUTS_TREE,
)

// state
const initialState = fromJS({
  loading: false,
  formData: {},
  tableData: {
    data: [],
    count: 0,
  },
  isWorkflowListLoad: false,
  workflowList: List([]),
  policies: List([]),
  userAssignList: List([]),
  userAssignListLoading: false,
  taskInputsTree: [],
})

// reducers
const jobTasksAdmin = handleActions(
  {
    [FETCH_TASKS_TABLE_DATA_SUCCESS]: (state, action) =>
      state.set('loading', false).set('tableData', Map(action.payload)),
    [FETCH_TASKS_TABLE_DATA_FAILURE]: state =>
      state
        .set('loading', false)
        .set('tableData', initialState.get('tableData')),
    [FETCH_TASK_FORM_DATA]: state => state.set('loading', true),
    [LOAD_TASK_TABLE_DATA]: (state, action) =>
      state.set('loading', Boolean(action.payload)),
    [FETCH_TASK_FORM_DATA_SUCCESS]: (state, action) =>
      state.set('formData', Map(action.formData)).set('loading', false),
    [FETCH_TASK_FORM_DATA_FAILURE]: state =>
      state.set('formData', initialState.get('formData')).set('loading', false),
    [FETCH_WORKFLOW_LIST]: state => state.set('isWorkflowListLoad', true),
    [FETCH_WORKFLOW_LIST_SUCCESS]: (state, action) =>
      state
        .set('workflowList', List(action.payload))
        .set('isWorkflowListLoad', false),
    [FETCH_WORKFLOW_LIST_FAILURE]: state =>
      state
        .set('workflowList', initialState.get('workflowList'))
        .set('isWorkflowListLoad', false),
    [FETCH_TASK_POLICIES_LIST_SUCCESS]: (state, action) =>
      state.set('policies', List(action.payload)),
    [FETCH_TASK_POLICIES_LIST_FAILURE]: state =>
      state.set('policies', initialState.get('policies')),
    [TASKS_TABLE_POSITION_UPDATE_SUCCESS]: (
      state,
      { payload: { index, position } },
    ) => {
      const { data, count } = state.get('tableData').toJS()
      data[index].position = position

      return state.set(
        'tableData',
        Map({
          data,
          count,
        }),
      )
    },
    [CLEAR_TASKS_STATE]: () => initialState,
    [CLEAR_TASK_FORM_DATA]: state =>
      state.set('formData', initialState.get('formData')),
    [CLEAR_TASKS_STATE_DATA]: state =>
      state.set('tableData', initialState.get('tableData')),
    [FETCH_TASK_ASSIGN_LIST_SUCCESS]: (state, action) =>
      state
        .set('userAssignList', List(action.payload))
        .set('userAssignListLoading', false),
    [DELETE_TASK_ASSIGN]: state => state.set('userAssignListLoading', true),
    [CHANGE_TASK_ASSIGN]: state => state.set('userAssignListLoading', true),
    [FETCH_TASK_ASSIGN_LIST]: state => state.set('userAssignListLoading', true),
    [FETCH_TASK_ASSIGN_LIST_FAILURE]: state =>
      state.set('userAssignListLoading', false),
    [FETCH_TASK_INPUTS_TREE_SUCCESS]: (state, { payload }) =>
      state.set(
        'taskInputsTree',
        List(
          payload.map(el => ({
            ...el,
            options:
              el.inputs?.map(({ id, title }) => ({
                value: id,
                label: title,
              })) || [],
          })),
        ),
      ),
    [FETCH_TASK_INPUTS_TREE_FAILURE]: state =>
      state.set('taskInputsTree', List([])),
    [SET_IS_INPUTS_TREE_FETCHING]: (state, action) =>
      state.set('isInputsTreeFetching', action.payload),
  },
  initialState,
)

export default jobTasksAdmin
